import baseConfig from "./base";

const config = {
  appEnv: "dist",
  apiBaseUrl: "https://wcimhbo.dive-digitalvenue.com/api/v1",
  backofficeUrl: "https://wcimhbo.dive-digitalvenue.com",
  getStreamApiKey: "j5nrqgqfc48a",
  language: "it"
};

export default Object.freeze({ ...baseConfig, ...config });
